import api from '../../../services/api'
import { Institution } from '../../../domain/entities/institution.entity'
import { BaseRepository } from './base.repository'
import { Storage } from '@/constants/Enum'
import { Course, ICourseCreate } from '@/domain/entities/course.entity'

export class InstitutionRepository extends BaseRepository {
  token = localStorage.getItem(Storage.token)

  private static Instance: InstitutionRepository = null
  public static GetInstance() {
    const instance = this.Instance ? this.Instance : new InstitutionRepository()
    return instance
  }

  async listRandom(category_id: string): Promise<Institution[]> {
    const { data } = await api.get<{ institutions: Institution[] }>(
      `/institutions/${category_id}`,
    )
    return (data as any).neighborhood
  }

  async list(): Promise<Institution[]> {
    const response = await api.get('/institutions', {
      params: { status: 'active' },
    })
    return response.data.institutions as Institution[]
  }

  async findByName(name: string): Promise<Institution[]> {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get('/institutions', {
      params: {
        name,
      },
      headers,
    })
    return response.data.institutions
  }

  async listCities(category_id: string): Promise<string[]> {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get(`/institutions/cities/${category_id}`, {
      headers,
    })
    return response.data.cities
  }

  async listNeighborhoods(
    category_id: string,
    city: string,
  ): Promise<string[]> {
    const response = await api.get(`/institutions/${category_id}/${city}`)
    return response.data.neighborhood
  }

  async listImagens(institution_id: string) {
    const response = await api.get(`/institutions/${institution_id}/images`)
    return response.data.images
  }

  async getCursoById(id: number) {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get('/courses/' + id, {
      headers,
    })

    return response.data as { course: Course }
  }

  async adminList() {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get('/admin/institutions', {
      headers,
    })

    return response.data.institutions
  }

  async adminShowById(token: string, id: string) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.get('/admin/institutions/' + id, {
      headers,
    })

    return response.data
  }

  async adminCreate(token: string, data: any) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.post('/admin/institutions', data, {
      headers,
    })

    return response.data.institution
  }

  async adminShowCourse(token: string, id: string) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.get('/admin/courses/' + id, {
      headers,
    })

    return response.data
  }

  async adminAtualizarCursoAtivado(
    token: string,
    id: number,
    course_id: number,
  ) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.put(
      '/admin/institutions/' + id + '/courses/' + course_id + '/ativar',
      {},
      {
        headers,
      },
    )

    return response.data
  }

  async updateInstitution(token: string, id: number, data: any) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.put(
      '/admin/institutions/' + id,
      { data },
      {
        headers,
      },
    )

    return response.data.institution
  }

  async uploadImage(token: string, id: string, file: File) {
    const formData = new FormData()
    formData.append('icon', file)

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    }
    const response = await api.put(
      '/admin/institutions/' + id + '/icon',
      formData,
      {
        headers,
      },
    )

    return response.data.institution
  }

  async addCourse({ data, token }: { token: string; data: ICourseCreate }) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.post(
      '/admin/courses',
      {
        ...data,
        status: 'ATIVO',
        active: true,
      },
      {
        headers,
      },
    )

    return response.data
  }

  async deleteCourse(token: string, course_id: string) {
    const headers = { Authorization: `Bearer ${token}` }
    await api.delete('/admin/courses/' + course_id, {
      headers,
    })
  }

  async adminAtualizarCurso(token: string, course_id: string, curso: any) {
    const headers = { Authorization: `Bearer ${token}` }
    const response = await api.put(
      '/admin/courses/' + course_id,
      {
        data: curso,
      },
      {
        headers,
      },
    )

    return response.data.curso
  }

  async listInstitutions(
    category_id: number,
    city: string,
    neighborhood: string,
  ) {
    const headers = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'application/json',
    }

    const response = await api.get('/institutions', {
      headers,
      params: {
        category_id,
        city,
        neighborhood,
        status: 'active',
      },
    })

    return response.data
  }

  async listInstitutionImage(institution_id: string) {
    const headers = { Authorization: `Bearer ${this.token}` }
    const response = await api.get(
      '/admin/institutions/' + institution_id + '/images',
      {
        headers,
      },
    )
    return response.data.images
  }

  async addInstitutionImage(institution_id: string, file: File) {
    const formData = new FormData()
    formData.append('imagem', file)

    const headers = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'multipart/form-data',
    }
    const response = await api.post(
      '/admin/institutions/' + institution_id + '/images',
      formData,
      {
        headers,
      },
    )

    return response.data.instituicoes_imagem
  }

  async removeInstitutionImage(id: string) {
    const headers = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'multipart/form-data',
    }
    const response = await api.delete('/admin/institutions/imagens/' + id, {
      headers,
    })

    return response.data.imagem
  }
}
